<div class="blueMode modal-dialog">
  <div class="dialog-header">
    <h1 mat-dialog-title>{{ titreModal }}</h1>
    <button mat-icon-button [mat-dialog-close]="undefined" matTooltip="Annuler">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <div class="bloc-sous-titre">{{ sousTitreModal }}</div>

    <div>
      <form [formGroup]="formulaireRefus">
        <div class="bloc-ligne">
          <mat-form-field class="width-80" appearance="fill">
            <mat-label>Motif de refus (facultatif) :</mat-label>
            <textarea matInput [formControlName]="'motif'" placeholder="Motif de refus"></textarea>
          </mat-form-field>
        </div>
      </form>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-raised-button color="warn" matTooltip="Confirmer le refus" [disabled]="!formulaireRefus.valid" (click)="enregistrerRefus()">
      Refuser la demande
    </button>
    <button mat-raised-button color="accent" [mat-dialog-close]="undefined" matTooltip="Annuler">Non</button>
  </mat-dialog-actions>
</div>
